import { Box, Grid, useMediaQuery } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { InputSelectFieldGrid, InputTextFieldGrid } from "../../components";
import FavoritesSales from "../../components/sale/FavoritesSales";
import LastSales from "../../components/sale/LastSales";
import { confirmAlert, errorAlert } from "../../helpers/alerts";
import { setDenominations, setSegments, setSelectedProduct, setShowDetail, setUpdate } from "../../redux/slices/sale/airTimeSlice";
import xml from "../../helpers/xml";
import { currencyFormatter, hideEmail, randomNumber, validateEmptyFields } from "../../helpers/util";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getBagPINProductsService, getBagPINSegmentsService, getBagService } from "../../services/client/bagService";
import Swal from "sweetalert2";
import { setCurrentBag, setPINProducts, setPINSegments } from "redux/slices/client/bagSlice";
import { setSession } from "redux/slices/sessionSlice";
import { doStoreSale, sendTiketByEmail } from "services/sale/pdsService";
import Images from "assets/images";
import theme from "config/theme";

const ElectronicPinSaleScreen = () => {
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const { bags, accountBalance, sale: salepointId } = useSelector(store => store.session);
  const balance_bag = bags.find(bag => bag.type === 'PDS');

  const { showDetail } = useSelector(store => store.airTimeSale);
  const { control, handleSubmit, setValue, watch, reset, setFocus } = useForm();
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [amounts, setAmounts] = useState(null)
  const { segment, product } = watch();
  const {
    currentBag,
    pinSegments,
    pinProducts,
  } = useSelector((store) => store.bags);
  useEffect(() => {
    dispatch(setShowDetail(false))
    getBagService(balance_bag.id).then(response => {
      dispatch(setCurrentBag(response))
    }).catch((e) => console.error(e))
    getBagPINSegmentsService(balance_bag.id).then(list => {
      dispatch(setPINSegments(list));
    }).catch(error => errorAlert(error))
    dispatch(setSelectedProduct(null));
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const data = watch();
    let disable = validateEmptyFields(data, {});
    if (!disable) {
      if (data.phone !== data.confirmPhone)
        disable = true;
    }
    setDisabled(disable);
    // eslint-disable-next-line
  }, [watch()]);

  useEffect(() => {
    if (segment) {
      const selected = pinSegments.find(({ idSegment }) => segment === idSegment.id);
      dispatch(setSelectedProduct({ image: selected.fd }));
      setValue('amount', null)
      getBagPINProductsService(balance_bag.id, segment)
        .then((response) => {
          dispatch(setPINProducts(response))
          if (response.length === 1)
            setValue('product', response[0].idProduct.id)

        })
        .catch((e) => errorAlert(e))
    }
    // eslint-disable-next-line
  }, [segment]);

  useEffect(() => {
    if (product) {
      const selected = pinProducts.find(({ idProduct }) => product === idProduct.id);
      dispatch(setSelectedProduct({ image: selected.fd }));
      setValue('amount', null)
      if (selected.idProduct.fixedAmount)
        setAmounts(selected.idProduct.amounts)
      else
        setAmounts(null)
    }
    // eslint-disable-next-line
  }, [product]);


  const submit = async ({ segment, product, phone, amount }) => {
    setLoading(true)
    try {
      const selected_segment = pinSegments.find(({ idSegment }) => idSegment.id === segment);
      const selected_product = pinProducts.find(({ idProduct }) => idProduct.id === product);
      const selected_amount = amounts ? amounts.find(({ amount: amt }) => amt == amount) : null;
      const externalTrace = randomNumber(100000, 999999);
      
      const sale = {
        username: currentBag.username,
        password: currentBag.password,
        storeId: currentBag.storeId,
        provider: selected_segment.idSegment.carrierId,
        amount,
        phone,
        productDetail: selected_amount ? selected_amount.sku : selected_product.idProduct.code,
        externalTrace,
        salepointId
      }
      let xmlResponse = await doStoreSale(sale);
      xmlResponse = new xml(xmlResponse)
      const error = xmlResponse.getElementValue("phon:ProviderResponseCode");
      if (error !== '00') {
        let message = xmlResponse.getElementValue("phon:ProviderResponseMessage");
        message = message == 'InsufficientBalance' ? 'No cuenta con suficiente saldo para esta operación' : message;
        errorAlert({ message: message || "Error" })
      } else {
        reset({ segment: '', product: '' });
        dispatch(setSelectedProduct(null));
        dispatch(setSession({ accountBalance: accountBalance - amount }))
        confirmAlert({
          icon: "success",
          title: "Recarga Éxitosa",
          html: `<div id="ticket">
          <h3>Número de autorización ${xmlResponse.getElementValue("phon:AuthCode")}</h3>
          <div>Teléfono: ${phone}</div>
          <div>Segmento: ${selected_segment.idSegment.name}</div>
          <div>Servicio: ${selected_product.idProduct.name}</div>
          <div>Monto: ${currencyFormatter.format(sale.amount)}</div>
          <div>Fecha: ${moment().format('DD/MM/YYYY HH:mm:ss')}</div>
          </div>`,
          showCancelButton: true,
          showDenyButton: true,
          cancelButtonText: "Cerrar",
          confirmButtonText: "Descargar comprobante",
          denyButtonText: "Enviar por correo electrónico",
          preConfirm: () => {
            return html2canvas(document.querySelector('.swal2-show')).then(
              canvas => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF();
                pdf.addImage(imgData, 'PNG', 25, 0);
                pdf.save('comprobante.pdf');
              }
            );
          },
          onDenied: () => {
            Swal.fire({
              title: 'Ingresa el correo electrónico',
              input: 'text',
              inputAttributes: {
                autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonText: 'Enviar',
              showLoaderOnConfirm: true,
              cancelButtonColor: "#ED3726",
              preConfirm: (email) => {
                return sendTiketByEmail(email, {
                  auth: xmlResponse.getElementValue("phon:AuthCode"),
                  phone: phone,
                  segment: selected_segment.idSegment.name,
                  product: selected_product.idProduct.name,
                  amount: sale.amount,
                  date: moment().format('DD/MM/YYYY hh:mm:ss'),
                }).then(() => {
                  confirmAlert({
                    icon: "success",
                    title: "Enviado",
                    text: `Se ha enviado el ticket de la transacción al correo electrónico ${hideEmail(email)}`,
                    showCancelButton: false,
                  })
                }).catch((error) => {
                  Swal.showValidationMessage(error)
                })
              },
              allowOutsideClick: () => !Swal.isLoading()
            })
          }
        })
      }
    } catch (e) {
      console.error(e);
      if (e.code === 501)
        errorAlert({ message: e.message })
      else
        errorAlert({ message: 'Ha ocurrido un error al realizar la recarga, Vuelve a intentarlo y si el error persiste contacta a tu administrador.' })
    } finally {
      setLoading(false)
      dispatch(setUpdate(moment().unix()))
    }
  }

  const handlerSelectFavorite = (product) => {
    setTimeout(() => {
      setTimeout(() => {
        setFocus('phone')
      }, 500);
      if (product._id === product)
        return
      dispatch(setSegments([]))
      dispatch(setDenominations([]))
      setValue('segment', product.segment._id)
      setValue('product', product._id)
    }, 100);
  }

  return (
    <Box mt={2}>
      <Box border={'2px solid ' + theme.secundaryColor} borderRadius={4} padding={4} sx={{
        backgroundImage: `url('${Images.icon.pos_bg}')`,
        backgroundSize: 'contain',
        backgroundRepeat: 'repeat-x',
      }}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
        >
          <Grid container item rowSpacing={4} maxWidth={'30vw'} backgroundColor={theme.backgroundColor} my={-4} p={2}>
            <InputSelectFieldGrid
              name={"segment"}
              xs={12}
              control={control}
              required={"Debes seleccionar un segmento"}
              label={"Segmento"}
              data={pinSegments}
              // size={'large'}
              formatter={(data) =>
                data?.map(({ idSegment }) => ({ id: idSegment.id, name: idSegment.name }))
              }
            />
            <InputSelectFieldGrid
              xs={12}
              control={control}
              name={"product"}
              required={"Debes seleccionar un segmento"}
              label={"Servicio"}
              data={pinProducts}
              // size={'large'}
              disabled={segment == null}
              formatter={(data) =>
                data?.map(({ idProduct }) => ({ id: idProduct.id, name: idProduct.name }))
              }
            />

            {
              amounts ? (
                <InputSelectFieldGrid
                  control={control}
                  name={"amount"}
                  required={"Debes seleccionar un monto"}
                  label={"Monto"}
                  data={amounts}
                  // size={'large'}
                  disabled={product == null}
                  formatter={(data) =>
                    data?.map((item) => ({ id: item.amount, name: currencyFormatter.format(item.amount) + (item.label ? ` (${item.label})` : '') }))
                  }
                />
              ) : (
                <InputTextFieldGrid
                  control={control}
                  name={"amount"}
                  placeholder={"Monto"}
                  rules={{
                    required: { value: true, message: "Debes agregar el monto" },
                  }}
                  // size={'large'}
                  disabled={product == null}
                  inputProps={{ type: 'number' }}
                  inputType={"number"}
                  step={"any"}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderWidth: '0px',
                    },
                    '& .MuiInputBase-input': {
                      backgroundColor: '#FFFFFF',
                      borderRadius: '8px',
                      textAlign: 'center',
                      color: theme.contrastColor,
                      fontWeight: 'bold',
                      fontSize: '40px',
                      padding: '20px 0px',
                    }
                  }}
                />
              )
            }
            <InputTextFieldGrid
              xs={12}
              control={control}
              name={"phone"}
              placeholder={"Número celular"}
              disabled={segment == null}

              rules={{
                required: { value: true, message: "Debes agregar el número celular" },
                maxLength: { value: 10, message: "El número celular es de máximo 10 dígitos" },
                pattern: { value: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, message: "Número celular inválido" },
              }}
              // size={'large'}
              inputType={'tel'}
              inputProps={{
                type: 'tel',
                maxLength: 10
              }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '& .MuiInputBase-input': {
                  backgroundColor: '#FFFFFF',
                  borderRadius: '8px',
                  textAlign: 'center',
                  color: theme.contrastColor,
                  fontWeight: 'bold',
                  fontSize: '40px',
                  padding: '20px 0px',
                }
              }}
            />
            <InputTextFieldGrid
              xs={12}
              control={control}
              name={"confirmPhone"}
              placeholder={"Confirmar número"}
              disabled={segment == null}

              rules={{
                required: { value: true, message: "Debes agregar el número celular" },
                maxLength: { value: 10, message: "El número celular es de máximo 10 dígitos" },
                pattern: { value: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, message: "Número celular inválido" },
              }}
              // size={'large'}
              inputType={'tel'}
              inputProps={{
                type: 'tel',
                maxLength: 10
              }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderWidth: '0px',
                },
                '& .MuiInputBase-input': {
                  backgroundColor: '#FFFFFF',
                  borderRadius: '8px',
                  textAlign: 'center',
                  color: theme.contrastColor,
                  fontWeight: 'bold',
                  fontSize: '40px',
                  padding: '20px 0px',
                }
              }}
            />
            <Grid
              container
              item
              xs={12}
              justifyContent={"center"}
            >
              <LoadingButton
                loading={loading}
                sx={{
                  backgroundColor: theme.contrastColor,
                  borderRadius: 25,
                  color: "white",
                  padding: '12px 64px',
                  boxShadow: 'none',
                  fontWeight: "bold",
                  fontSize: '32px',
                  textTransform: 'none',
                  '&:disabled': {
                    color: "white",
                  }
                }}
                onClick={handleSubmit(submit)}
                disabled={disabled}
                variant="contained"
              >
                Recargar
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box >
  );
};

export default ElectronicPinSaleScreen;
